import React, { Component } from 'react';
import Inherit from '../../core/inherit';
import withNavigate from '../../core/withNavigate';
import CampaignsController from './campaigns.controller';
import { Button } from 'antd';
import { Flag, Plus } from 'lucide-react';

import { Layout, TableSkeleton, AnalyticsSkeleton, PageHeader } from '../common';
import { CampaignActions, CampaignDrawer, CampaignsTable, CampaignAnalytics } from './elements';

class ShelfCampaigns extends Inherit(CampaignsController, Component) {
    state = {
        isOpen: false,
        loading: true,
        campaigns: [],
        rows: [],
        stores: [],
        editMode: false,
        editingCampaign: null
    };

    render() {
        const { campaigns, rows, loading, isOpen, stores, editMode, editingCampaign } = this.state;

        return (
            <Layout current="campaigns">
                {this.props.contextHolder}

                <PageHeader
                    icon={<Flag />}
                    iconTone="violet"
                    title="Campañas"
                    description="Gestiona las campañas de Trade Marketing"
                    actions={
                        <Button type="primary" icon={<Plus />} onClick={() => this.setIsOpen(true)} disabled={loading}>
                            Nueva Campaña
                        </Button>
                    }
                />

                {loading ? (
                    <div className="space-y-4">
                        <AnalyticsSkeleton count={4} />
                        <TableSkeleton rows={10} columns={8} />
                    </div>
                ) : (
                    <div className="space-y-4">
                        {/* Analytics */}
                        <CampaignAnalytics campaigns={campaigns} />

                        {/* Search & Table */}
                        <CampaignActions setRows={this.setRows.bind(this)} campaigns={campaigns} />
                        <CampaignsTable
                            rows={rows}
                            loading={loading}
                            navigateCampaign={this.navigateCampaign.bind(this)}
                            onEdit={this.openEditDrawer.bind(this)}
                        />
                        <CampaignDrawer
                            contextHolder={this.props.contextHolder}
                            isOpen={isOpen}
                            setIsOpen={this.setIsOpen.bind(this)}
                            createCampaign={this.createCampaign.bind(this)}
                            updateCampaign={this.updateCampaign.bind(this)}
                            stores={stores}
                            editMode={editMode}
                            campaignData={editingCampaign}
                        />
                    </div>
                )}
            </Layout>
        );
    }
}

export default withNavigate(ShelfCampaigns);
